module.exports = __webpack_public_path__ + "static/scale-model-of-terrace-hill-historic-site-in-des-moines-iowa-3d979415b1318e6409d5a0fcacaec066.png";